import React, { CSSProperties } from "react";

interface DoctorsExportProps {
  gap?: number;
  showNavigation?: boolean;
  children?: React.ReactNode;
}

export const DoctorsExport: React.FC<DoctorsExportProps> = ({
  gap = 24,
  showNavigation = true,
  children,
}) => {
  const containerStyles: CSSProperties = {
    position: "relative",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
  };

  const childCount = React.Children.count(children);
  const hasChildren = childCount > 0;

  const scrollContainerStyles: CSSProperties = {
    display: "flex",
    flexWrap: "nowrap",
    gap: `${gap}px`,
    overflowX: "auto",
    scrollBehavior: "smooth",
    padding: "16px 0",
    minHeight: "200px",
    justifyContent: "center",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  };

  const arrowStyles: CSSProperties = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    backgroundColor: "white",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    cursor: "pointer",
    display: "none",
    alignItems: "center",
    justifyContent: "center",
  };

  if (!hasChildren) {
    return (
      <div className="doctors-carousel" style={containerStyles}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 24px",
            backgroundColor: "#f9fafb",
            borderRadius: "8px",
            border: "2px dashed #d1d5db",
            minHeight: "200px",
          }}
        >
          <div style={{ textAlign: "center", color: "#6b7280" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>👨‍⚕️</div>
            <h3 style={{ margin: "0 0 8px", fontWeight: 600 }}>No doctors yet</h3>
            <p style={{ margin: 0, fontSize: "0.875rem" }}>
              Add doctors manually or sync from your system
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="doctors-carousel" style={containerStyles}>
      {showNavigation && (
        <button className="carousel-prev" style={{ ...arrowStyles, left: "4px" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </button>
      )}

      <div className="carousel-scroll" style={scrollContainerStyles}>
        {children}
      </div>

      {showNavigation && (
        <button className="carousel-next" style={{ ...arrowStyles, right: "4px" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9,18 15,12 9,6" />
          </svg>
        </button>
      )}
    </div>
  );
};
